export default __webpack_public_path__ + "static/media/header-tick.7d3ee8db.svg";